import { render, staticRenderFns } from "./wayPoints.vue?vue&type=template&id=46e608e4&"
import script from "./wayPoints.vue?vue&type=script&lang=js&"
export * from "./wayPoints.vue?vue&type=script&lang=js&"
import style0 from "./wayPoints.vue?vue&type=style&index=0&id=46e608e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports